import React from 'react';

import { 
	func, array, string, object, 
} from 'prop-types';
import {sortScore,extractGradeByDate} from '../../../logics/score';

export default class Container extends React.Component {
    static propTypes = {
    	render : func.isRequired,
    	scores : array.isRequired,
    	uid : string.isRequired,
    	recipe : object,
    	favs : array,
    	onClickStar : func.isRequired,
    	onClickThumbs : func.isRequired,
    }
    constructor(props){
    	super(props);
    	this.state={
    		updatingFav : false,
    		updatingThumb : false
    	};
    }
    render(){
    	const {render,scores = [],recipe,favs,uid,onClickStar,onClickThumbs,...other} = this.props;
    	const fav = favs&&favs.includes(recipe.id);
    	const userScores = sortScore(scores.filter(s=>s.uid === uid)).map(extractGradeByDate);
    	const likeFrom = recipe.likeFrom || [];
    	const thumbFrom = recipe.thumbFrom || [];
    	const hasThumbOfMe = thumbFrom.includes(uid);
    	return render({
    		scores : userScores,
    		recipe,
    		fav,
    		likeFrom,
    		thumbFrom,
    		hasThumbOfMe,
    		updatingFav : this.state.updatingFav,
    		onClickStar : ()=>{
    			this.setState({
    				updatingFav : true,
    			});
    			onClickStar && onClickStar(recipe,fav===true,uid,()=>{
    				this.setState({
    					updatingFav : false,
    				});
    			});
    		},
    		updatingThumb : this.state.updatingThumb,
    		onClickThumbs : ()=>{
    			this.setState({
    				updatingThumb : true,
    			});
    			onClickThumbs && onClickThumbs(recipe,uid,()=>{
    				this.setState({
    					updatingThumb : false,
    				});
    			});
    		},
    	},other);
    }
}